import moment from "moment-timezone";

export const userTimezone = moment.tz.guess();
